/** アプリケーション固有名詞（ブランド名） */
export const APP_NAME = "Sekitori";

/** BugReporter 報告ページURL */
export const BUGREPORTER_URL =
  "https://bugreporter.mediowl.ai/report/b3e4cf6e-d907-4b52-9f1c-7576a3798630";
